export const RELOAD_MAP = "RELOAD_MAP";

export const reloadMapAction = () => {
    return {
        type: RELOAD_MAP,
    };
};
